export const INTERNAL_TASKS_STATUS = {
  APPROVAL: 'APPROVAL',
  DKC_APPROVAL: 'DKC_APPROVAL',
  SOAC_APPROVAL: 'SOAC_APPROVAL',
  UNDER_REVISION: 'UNDER_REVISION',
  APPROVED: 'APPROVED',
  APPROVED_WITH_CHANGES: 'APPROVED_WITH_CHANGES',
  PARTIALLY_APPROVED: 'PARTIALLY_APPROVED',
  OVERDUE: 'OVERDUE',
  REJECTED: 'REJECTED',
  CANCELLED_BY_INITIATOR: 'CANCELLED_BY_INITIATOR'
} as const

export const INTERNAL_TASKS_STATUS_TITLE = {
  [INTERNAL_TASKS_STATUS.APPROVAL]: 'согласование',
  [INTERNAL_TASKS_STATUS.DKC_APPROVAL]: 'согласование ДУК',
  [INTERNAL_TASKS_STATUS.SOAC_APPROVAL]: 'согласование СОАЦ',
  [INTERNAL_TASKS_STATUS.UNDER_REVISION]: 'на доработке',
  [INTERNAL_TASKS_STATUS.APPROVED]: 'согласована',
  [INTERNAL_TASKS_STATUS.APPROVED_WITH_CHANGES]: 'согласована с изменениями',
  [INTERNAL_TASKS_STATUS.PARTIALLY_APPROVED]: 'согласована частично',
  [INTERNAL_TASKS_STATUS.OVERDUE]: 'просрочена',
  [INTERNAL_TASKS_STATUS.REJECTED]: 'отклонена',
  [INTERNAL_TASKS_STATUS.CANCELLED_BY_INITIATOR]: 'отменена инициатором'
} as const
